import React, { FC } from 'react';
import { GridColumn } from "@progress/kendo-react-grid";
import { protectedResources } from '../../authConfig';
import { BaseGrid } from '../../components/KendoGrid/BaseGrid';
import { FiveDecimalPlaceNumericFilterCell } from '../../components/KendoGrid/NumericFilterCell';
import { kitRunStatuses } from '../../models/kitRunStatus';
import { DropdownFilterCell } from '../../components/KendoGrid/DropDownFilterCell';
import { SortDescriptor } from '@progress/kendo-data-query';

interface SubmittedKitRunListProps {
    id?: number,
    submittedKitRunVolume?: number,
    hideStatusColumn?: boolean,
    children?: React.ReactNode
}

const statusList = [kitRunStatuses[1], kitRunStatuses[2], kitRunStatuses[3], kitRunStatuses[4]]

const SubmittedKitRunList: FC<SubmittedKitRunListProps> = (props): JSX.Element => {
    let filter;
    if (props.id) {
        filter = [{
            field: "SubmittedKitId",
            operator: "eq",
            value: props.id,
        }];
    }

    const recentEntriesFirstSort = [{
        field: "Id",
        dir: "desc"
    } as SortDescriptor];

    const DateCell = (myDate: any) => {

        let formattedDate = new Date(myDate.dataItem.runDate).toLocaleDateString()

        return (
            <td>
                {formattedDate}
            </td>
        )
    }

    const KitRunStatusCell = (data: any) => {
        return (
            <td>
                {kitRunStatuses[data.dataItem.kitRunStatusId].name}
            </td>
        )
    }

    const CategoryFilterCell = (props: any) => (
        <DropdownFilterCell
            {...props}
            data={statusList}
            defaultItem={""}
            dataItemKey={"id"}
            textField={"name"}
        />
    );

    const PipetVolumeCell = (data: any) => {
        if (props.submittedKitRunVolume &&
            (data.dataItem.pipetVolume > (props.submittedKitRunVolume * 1.03) ||
                data.dataItem.pipetVolume < (props.submittedKitRunVolume * 0.97))) {
            return <td style={{ color: "red" }}>
                {data.dataItem.pipetVolume}
            </td>;
        } else {
            return <td>
                {data.dataItem.pipetVolume}
            </td>;
        }
    }

    const columnWidth = "175px";

    return (
        <BaseGrid verb={'POST'} pageTitle='Submitted Kit Run List' endpoint={protectedResources.apiSubmittedKitRun.endpoint + "KendoGridRead"} redirectUrl="/submitted-kit-run-manage/"
            filter={filter} intialSort={recentEntriesFirstSort} excelFunction={(submittedKitRun: any) => {
                const skr = { ...submittedKitRun };
                if (skr.kitRunStatusId >= 1 && skr.kitRunStatusId <= 4) {
                    skr.kitRunStatusId = kitRunStatuses[skr.kitRunStatusId].name;
                }
                return skr
            }}>
            <GridColumn width={columnWidth} filter="numeric" field="pipetVolume" title="Pipet Volume" cell={PipetVolumeCell} filterCell={FiveDecimalPlaceNumericFilterCell} />
            <GridColumn width={columnWidth} filter="numeric" field="measurement" title="Measurement" filterCell={FiveDecimalPlaceNumericFilterCell} />
            <GridColumn width={columnWidth} filter="date" field="runDate" title="Run Date" cell={DateCell} />
            {!props.hideStatusColumn &&
                <GridColumn width={columnWidth} field="kitRunStatusId" title="Status" filter="numeric" cell={KitRunStatusCell} filterCell={CategoryFilterCell} />}
            <GridColumn field="comments" title="Latest Comment" />
        </BaseGrid >
    );
}

export default SubmittedKitRunList;